// extracted by mini-css-extract-plugin
export default {"itemWrapper":"SelectItem_itemWrapper__xjeFt","itemLongWrapper":"SelectItem_itemLongWrapper__inHvD","selected":"SelectItem_selected__yjLUC"};